module.exports = __webpack_public_path__ + "img/index-4.30ae9f5b.png";